export const Data = {
  Products: [
    { name: 'Buy', href: '/buy' },
    { name: 'Refinance', href: '/refinance' },
    { name: 'Home Equity Loan', href: '/home-equity-loan' },
    { name: 'Home Equity Line', href: '/home-equity-line' },
    { name: 'Find Home', href: '/find-home' }
  ],
  About: [
    { name: 'Why Nuborrow', href: '/why' },
    { name: 'Join Us', href: '/join' },
    { name: 'Learn', href: '/learn' },
    { name: 'Team', href: '/team' }
  ],
  Reviews: [{ name: 'Google', href: '/reviews/' }],
  Support: [
    { name: 'Customer Care', href: '/care' },
    { name: '1 888 372 5588', href: 'tel:1 888 372 5588' }
  ],
  Social: [
    { name: 'Facebook', href: 'https://www.facebook.com/nuborrow/' },
    { name: 'Twitter', href: 'https://twitter.com/nuborrow_' },
    { name: 'YouTube', href: 'https://www.youtube.com/@nuborrow-firstandsecondmor5173' },
    { name: 'Instagram', href: 'https://www.instagram.com/nuborrow/' }
  ],
  legal: [
    { name: 'Privacy policy', href: '/privacy-policy/' },
    { name: 'Terms of use', href: '/404/' },
    { name: 'Legal', href: '/404' }
  ]
};
